<template>
    <div id="univer-group-details" class="univer-group-category-list page univer-group-details">
        <div class="univer-group-category-list__head">
            <div class="container-xl">
                <div class="row">
                    <div class="col-12">
                        <div class="breadcrumb breadcrumb--desctop">
                            <router-link :to="{ name:'Home'}">
                                {{ lang('breadcrumb_kezdooldal') }}
                            </router-link>
                            <span class="separate">></span>                            
                            <router-link :to="{ name:'UniverGroup', params:{main_group:currentGroupMainParentCategorySlug }}">
                                {{ currentGroupMainParentCategoryName }}
                            </router-link>
                            <span class="separate">></span>
                            <router-link :to="{ name:'UniverGroupSubCategoryPage', params:{group_slug:currentGroupCategoryParentSlug }}">
                                {{ currentGroupCategoryParentSlugName }}
                            </router-link>
                            <span class="separate">></span>
                            <span class="current-group">{{ currentGroupCategory.name }}</span>
                        </div>
                        <div class="breadcrumb--mobile breadcrumb">
                            <router-link :to="{ name:'UniverGroupSubCategoryPage', params:{group_slug:currentGroupCategoryParentSlug }}">
                                 {{ lang('vissza') }}
                            </router-link>
                        </div>
                        <div class="row subCategory-menu--mobile">
                            <div class="col-12">
                                <v-select :searchable="false" v-model="mobileClicedLink" :options="currentGroupSubCategories" :reduce="option => option.id" label="name" :placeholder="lang('univer_group_submenu_osszefoglalo')"></v-select>
                            </div>
                        </div>
                    </div>
                </div>               
                <div class="row">             
                    <div class="col-12 news-details__main-data">                      
                        <h1 data-share-title>{{ currentGroupCategory.name }}</h1>                       
                    </div>
                </div>
            </div>
        </div>
        <div class="univer-group-category-list__content">
            <div class="container-xl">
                <div class="row">
                    <div class="col-12 col-md-4 col-lg-3 sub-menu-rel-docs-wrap">
                        <ul class="subCategory-menu" v-if="currentGroupSubCategories.length > 0">
                            <li>
                                <router-link :to="{ name:'UniverGroupSubCategoryPage', params: { group_slug: currentGroupCategoryParentSlug}}">
                                    {{lang('univer_group_submenu_osszefoglalo')}}
                                </router-link>
                            </li>
                            <li v-for="categoryLink in currentGroupSubCategories" :key="categoryLink.id" :class="{'active-route': categoryLink.slug == currentGroupCategorySlug}">
                                <router-link  v-if="!hasHttp( categoryLink.slug)" :to="{ name:'UniverGroupDetails', params: { group_slug: currentGroupCategoryParentSlug, group_details_slug: categoryLink.slug}}">{{ categoryLink.name}}</router-link>
                                <a v-else target="_blank" :href="categoryLink.slug">
                                    {{ categoryLink.name}}
                                </a>
                            </li>
                        </ul>
                        <div class="related-docs" v-if="relatedDocs.length > 0">                           
                            <div class="row">
                                <div class="col-12">
                                    <h3>{{ lang('univer_group_kapcsolodo_dokumentumok')}}</h3>
                                </div>
                            </div>                      
                            <div class="row">
                                <div class="col-12" v-for="doc in relatedDocs" :key="doc.id">
                                    <RelatedDosc :name="doc.name" :slug="doc.document_id.path" :file_name="doc.document_id.file_name" />
                                </div>
                            </div>                                           
                        </div>  
                        <div class="banner-wrap" v-if="relatedBanners.length > 0">
                            <Banner v-for="banner in relatedBanners" :key="banner.id" 
                                    :name="banner.name"
                                    :target="banner.link"
                                    :src="banner.image.path"
                                    :file_name="banner.image.file_name" />
                        </div>                      
                    </div>
                    <div class="col-12 col-md-8 col-lg-9">
                        <div class="univer-group-category-list__content--main">
                            <div class="short_desc" v-if="currentGroupCategory.short_description" v-html="currentGroupCategory.short_description"></div>
                            <div class="desc content_description" v-html="currentGroupCategory.description "></div>
                            <div class="social-share-row">
                                <SocialShare />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
console.log('ola2')
import axios from 'axios'
import RelatedDosc from '@/components/pagesComponents/univerGroup/RelatedDocs.vue'
import Banner from '@/components/layoutComponents/Banner.vue'
import SocialShare from '@/components/layoutComponents/SocialShare.vue'

export default {
    data(){
        return {
            currentGroupCategory: {},            
            relatedDocs: [],
            relatedBanners: [],
            currentGroupCategoryParentSlugName: '',
            currentGroupMainParentCategoryName: '',
            currentGroupSubCategories: [],
            currentCategoryMetas: {
                meta_description: null,
                meta_image: null,
                meta_keywords: null,
                meta_title: null
            },
            mobileClicedLink: null
        }
    },
    components:{
        RelatedDosc,
        Banner,
        SocialShare
    },
    computed:{
        currentGroupCategorySlug(){
            return this.$route.params.group_details_slug;
        },
        currentGroupCategoryParentSlug(){
            return this.$route.params.group_slug;
        },
        currentGroupMainParentCategorySlug(){
            return this.$route.params.main_group;
        }          
    },
    watch:{
        $route: function(){ 
            this.currentGroupSubCategories = []             
            this.currentGroupParentSubCategories = []               
            this.getCurrentGroupCategoryData()          
        },
        mobileClicedLink: function(value) {
            if ( parseInt(this.currentGroupCategory.id) != parseInt(value)){
                this.changeMobileRoute()
            }            
        } 
    },
    methods:{
        getCurrentGroupCategoryData(){
            let _this = this;        
            let selectedLangId =this.$store.getters.getSelectedLang.id                         

            axios.get(process.env.VUE_APP_BIFROST_API_URL + '/category/' + _this.currentGroupCategorySlug + '?relations=1&relations_params[banner][relations]=1&relations_params[banner][where][0][0]=where&relations_params[banner][where][0][1]=status&relations_params[banner][where][0][2]=1&relations_params[banner][relations_params][banner_image][where][0][0]=where&relations_params[banner][relations_params][banner_image][where][0][1]=language_id&relations_params[banner][relations_params][banner_image][where][0][2]=' + selectedLangId + '&relations_params[banner][relations_params][banner_image][order_by][0][0]=sort_order&relations_params[banner][relations_params][banner_image][order_by][0][1]=asc&relations_params[download][where][0][0]=where&relations_params[download][where][0][1]=status&relations_params[download][where][0][2]=1&relations_params[download][order_by][0][0]=sort_order&relations_params[download][order_by][0][1]=asc&',{            
                params:{
                    "language_id": this.$store.getters.getSelectedLang.id                         
                }
            }).then(response => {
                // console.log('subcategory', response.data)
                if (response.data.status == true ){                    

                    if ( parseInt(response.data.category[0].status) === 1) {
                        _this.currentGroupCategory = response.data.category[0]
                        _this.getParentCategory()
                        _this.getMainParentSlugName()
                        _this.setShowContacts()
                        _this.mobileClicedLink = response.data.category[0].id
              
                        //related docs
                        if ( response.data.category[0].download){
                            _this.relatedDocs =  response.data.category[0].download
                        } else {
                            _this.relatedDocs = []
                        }

                         // //banner
                        if ( response.data.category[0].banner){
                            let banners = response.data.category[0].banner;                            
                            
                            banners.forEach(element => {
                                //need this because of the language_id parameter - if the lang id different, we don't get the banner_image
                                if (element.banner_image){
                                    element.banner_image.forEach(item => {
                                        _this.relatedBanners.push(item)
                                    })                                     
                                }
                            });                            
                        } else {
                            _this.relatedBanners = []
                        }
                      
                        //meta tags
                        if (response.data.category[0].meta_description != ''){
                            _this.currentCategoryMetas.meta_description = response.data.category[0].meta_description
                        } else {
                            _this.currentCategoryMetas.meta_description = null
                        }                       

                        if ( !response.data.category[0].meta_image ) {  
                            _this.currentCategoryMetas.meta_image = null
                        } else {
                            let meta_image_src = process.env.VUE_APP_BIFROST_API_URL_NO_PROJECTNAME + '/' + response.data.category[0].meta_image.path + response.data.category[0].meta_image.file_name
                            _this.currentCategoryMetas.meta_image = meta_image_src
                        }
                        
                        if (response.data.category[0].meta_keywords != ''){
                            _this.currentCategoryMetas.meta_keywords = response.data.category[0].meta_keywords
                        } else {
                            _this.currentCategoryMetas.meta_keywords = null
                        }
                        
                        if (response.data.category[0].meta_title != '') {
                            _this.currentCategoryMetas.meta_title = response.data.category[0].meta_title
                        } else {
                            _this.currentCategoryMetas.meta_title = null
                        }          
                        
                        _this.setCurrentMetaTags()
                    } else {
                        this.$router.push({name: '404-page'})
                    }                                       
                } else {
                    this.$router.push({name: '404-page'})
                }                                                              
            })
            .catch((err) => {
                console.log(err)
            }); 
        },
        getParentCategory(){
            let _this = this;                                 

            axios.get(process.env.VUE_APP_BIFROST_API_URL + '/category/' + _this.currentGroupCategoryParentSlug + '?relations=1&relations_params[sub_categories][where][0][0]=where&relations_params[sub_categories][where][0][1]=status&relations_params[sub_categories][where][0][2]=1&relations_params[sub_categories][order_by][0][0]=sort_order&relations_params[sub_categories][order_by][0][1]=asc' ,{            
                params:{
                    "language_id": this.$store.getters.getSelectedLang.id                         
                }
            }).then(response => {   
                // console.log("category parent", response.data)                        
                if (response.data.status == true ){
                    _this.currentGroupCategoryParentSlugName = response.data.category[0].name        
                    
                       
                    if ( response.data.category[0].sub_categories){
                       // _this.currentGroupSubCategories = response.data.category[0].sub_categories
                       _this.currentGroupSubCategories = [];
                             if (_this.$store.state.needPD){
                                for (var i=0; i <response.data.category[0].sub_categories.length ;i++)
                                {
                                    console.log(response.data.category[0].sub_categories[i].published_date)
                                    if (response.data.category[0].sub_categories[i].published_date <=  new Date().toISOString().slice(0, 19).replace('T', ' '))
                                          _this.currentGroupSubCategories.push(response.data.category[0].sub_categories  [i]);
                                }
                                
                            }
                            else
                                 _this.currentGroupSubCategories = response.data.category[0].sub_categories ;  
                    } else {
                        _this.currentGroupSubCategories = []
                    }

                    // _this.currentSlugSelect()
                }else {
                     _this.currentGroupSubCategories = []
                }                                                           
            })
            .catch((err) => {
                console.log(err)
            }); 
        },
        getMainParentSlugName(){
            let _this = this;                                 

            axios.get(process.env.VUE_APP_BIFROST_API_URL + '/category/' + _this.currentGroupMainParentCategorySlug + '?select[0]=name' ,{            
                params:{
                    "language_id": this.$store.getters.getSelectedLang.id                         
                }
            }).then(response => {          
                
                if (response.data.status == true ){
                   _this.currentGroupMainParentCategoryName = response.data.category[0].name     

                }                                                           
            })
            .catch((err) => {
                console.log(err)
            }); 
        },
        setCurrentMetaTags(){
            let _this = this            

            this.setMetaTags({
                title: _this.currentCategoryMetas.meta_title, 
                desc: _this.currentCategoryMetas.meta_description, 
                keywords: _this.currentCategoryMetas.meta_keywords, 
                ogType: 'article', 
                ogTitle: _this.currentCategoryMetas.meta_title,
                ogImage: _this.currentCategoryMetas.meta_image, 
                ogImageWidth: null, 
                ogImageHeight: null, 
                ogDesc: _this.currentCategoryMetas.meta_description
            })
        },
        changeMobileRoute(){                     
            
            let _this = this
            let clickedItemSlug = this.currentGroupSubCategories.find( item => parseInt(item.id) === parseInt(this.mobileClicedLink) ).slug 

            if (this.hasHttp(clickedItemSlug)){
                window.location = clickedItemSlug
            } else {
                if (clickedItemSlug != this.$route.params.group_details_slug){
                    this.$router.push({ 
                        name:'UniverGroupDetails', 
                        params: { 
                            group_slug: _this.currentGroupCategoryParentSlug, 
                            group_details_slug: clickedItemSlug
                        }
                    })
                }
                
            }      
                          
        },
         setShowContacts(){
            let _this = this
            let emailItems = document.getElementsByClassName("show_contact");            
            
            setTimeout(()=> {
                // console.log('emailItems', emailItems.length)
                for (var i = 0 ; i < emailItems.length; i++) {
                    emailItems[i].addEventListener('click' , _this.showAddresses , false )
                }
            }, 500)
            

        },
        showAddresses(event){
            console.log('clickec', event.target)
            // let _this = this
            let clickedItem = event.target
            let contactInfoId = parseInt(clickedItem.getAttribute('data-contact'))
            let contactInfo = null            
            
            axios.get(process.env.VUE_APP_BIFROST_API_URL + '/contact/' + contactInfoId,{            
                params:{
                    "language_id": this.$store.getters.getSelectedLang.id                         
                }
            }).then(response => {
                // console.log('contacts: ', response.data); 

                if (response.data.status == true ){                    
                    contactInfo = response.data.contact[0]  
                       
                    if (contactInfo != null){
                        let emailDomain = contactInfo.part2
                        let key = contactInfo.part1
                        let emailAddress = '<a href="mailto:' + key + '@' + emailDomain +'">' + key + '@' + emailDomain + '</a>'
                        
                        clickedItem.innerHTML  = emailAddress
                    }                
                }                                                         
            }).catch((err) => {
                console.log(err)
            });
                                                
        },      
    },
    created(){
        // console.log(this.$route.params)
        this.getCurrentGroupCategoryData()
    }
}
</script>